import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Showcases/Collections'
import { Structure } from 'pages/NWPlatform/Collections/Structure'
import { environmentRoute } from 'pages/NWPlatform/Routing'

export const collectionsRoute = createRoute({
  getParentRoute: () => environmentRoute,
  path: StaticRouteParameter.COLLECTIONS,
  loader: () => ({
    crumb: t('entity:showcase.collection', { count: 2 }),
  }),
})

export const collectionsOverviewLayoutRoute = createRoute({
  getParentRoute: () => collectionsRoute,
  id: 'collectionsOverviewLayout',
  component: Structure,
})

type ShowcasesOverviewSearch = {
  query?: string
}

export const collectionsOverviewRoute = createRoute({
  getParentRoute: () => collectionsOverviewLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): ShowcasesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
